import { defaultEnterBehaviour } from "@circle-react-shared/uikit/TipTap/Extensions/CustomKeymaps/common";
import { Extension } from "@tiptap/react";

export const MobileKeymap = Extension.create({
  name: "mobileKeymap",
  addKeyboardShortcuts() {
    const editor = this.editor;

    return {
      // Both Shift-Enter and Enter will replicate the default enter key behavior
      "Shift-Enter": () => defaultEnterBehaviour({ editor }),
      Enter: () => defaultEnterBehaviour({ editor }),
    };
  },
});
